/* eslint-disable no-unused-expressions */
<template>
  <div>
    <a-spin :spinning="loading">
      <div v-if="classSectionExamData">
        <!-- Exam Details -->
        <div class="row mb-2">
          <div class="col-12 col-md-6">
            <table class="table table-borderless table-sm mb-0">
              <tbody>
                <tr>
                  <th>Class</th>
                  <td>{{ classSectionExamData.school_class.name }}</td>
                </tr>
                <tr>
                  <th>Section</th>
                  <td>{{ classSectionExamData.section.name }}</td>
                </tr>
                <tr>
                  <th>Exam</th>
                  <td>{{ classSectionExamData.exam.name }}</td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>
                    <a-tag :color="classSectionExamData.declared ? 'green' : 'red'">{{ classSectionExamData.declared ? 'Declared' : 'Not declared' }}</a-tag>
                  </td>
                </tr>
                <tr>
                  <th>Grades</th>
                  <td>
                    <a-tag :color="classSectionExamData.grades ? 'green' : 'red'">{{ classSectionExamData.grades ? 'Enabled' : 'Disabled' }}</a-tag>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-12 col-md-6 text-right align-self-end">
            <!-- redeclare button -->
            <a href="javascript:;" :class="[`${classSectionExamData.declared ? 'btn-success' : 'disabled btn-dark'}`,'btn btn-sm btn-with-addon mr-2']"
              @click="handleResetExam(classSectionExamData.id)"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe', `${classSectionExamData.declared ? 'fe-stop-circle' : 'fe-play-circle'}`]" />
              </span>
              Reset
            </a>
            <!-- declare button -->
            <a href="javascript:;" :class="[`${classSectionExamData.declared ? 'disabled btn-dark' : 'btn-success'}`,'btn btn-sm btn-with-addon mr-2']"
              @click="handleDeclareExam"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe', `${classSectionExamData.declared ? 'fe-stop-circle' : 'fe-play-circle'}`]" />
              </span>
              {{ classSectionExamData.declared ? this.declared_status: this.declare_status}}
            </a>
          </div>
        </div>
        <div class="mt-3">
          <a-collapse v-model="activeKey" accordion>
            <a-collapse-panel :disabled="classSectionExamData.declared === 1" header="Add Marks" key="1">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <p class="text-muted mb-0">Click on subject name to add marks</p>
                <bulk-upload-student-mark :classSectionExamId="classSectionExamData.id" @created="handleSubjectMarkUpdate"/>
              </div>
              <div class="row">
                <div class="col-12">
                  <table class="table table-bordered table-sm-responsive">
                    <thead>
                      <tr>
                        <th>Roll nos</th>
                        <th
                          class="neo-exam-marks-subjects-cell"
                          v-for="examSubject in classSectionExamData.class_section_exam_subject"
                          :key="examSubject.id"
                          @click="openMarksFormModal(examSubject)"
                        >
                          {{ examSubject.subject.abbreviation }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="student in classSectionExamData.students" :key="student.id">
                        <th scope="row">{{ student.roll_no }}</th>
                        <td v-for="examSubject in classSectionExamData.class_section_exam_subject" :key="examSubject.id" class="px-2">
                          {{ getStudentSubjectMark(student.student_exam_mark, examSubject.subject.id) }}
                        </td>
                      </tr>
                      <tr v-if="!classSectionExamData.students.length">
                        <td :colspan="classSectionExamData.class_section_exam_subject.length + 1">
                          <no-data text="No Students" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </a-collapse-panel>
            <a-collapse-panel header="Exam Report" key="2" :disabled="false">
              <display-student-exam-report :examData="classSectionExamData"/>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
    </a-spin>

    <class-exam-marks-form @updated="handleSubjectMarkUpdate" />
  </div>
</template>

<script>
import moment from 'moment'
import { omit, find } from 'lodash'

import ClassExamMarksForm from '@/components/bosemexam/manage/Form/index'
import DisplayStudentExamReport from '@/components/bosemexam/manage/Report/index'
import BulkUploadStudentMark from '@/components/bosemexam/manage/Form/Bulk/index'

import NoData from '@/components/layout/NoData/index'

export default {
  name: 'DisplayClassSectionExam',
  components: {
    ClassExamMarksForm,
    DisplayStudentExamReport,
    NoData,
    BulkUploadStudentMark,
  },
  mounted: function() {
    this.getClassExamData()
  },
  // props: ['classSectionExamData'],
  computed: {
    classSectionExamId: function () {
      return this.$route.params.id
    },
  },
  data: function() {
    return {
      loading: false,
      classSectionExamData: null,
      activeKey: ['1'],
      declared_status: '',
      declare_status: '',
    }
  },
  methods: {
    moment,
    handleResetExam(classSecExamId) {
      this.$confirm({
        title: `Are you sure you want to undeclare exam !!`,
        content: `Click on the OK button to undeclare the exam!`,
        onOk: () => {
          this.$http
            .patch('/api/exam_status', { class_section_exam_id: classSecExamId })
            .then(() => {
              this.getClassExamData()
              this.declared_status = 'Exam Declared'
              this.declare_status = 'Declare Exam'
              this.loading = false
              this.$notification['success']({
                message: 'Successfully undeclared',
                description: 'Exam has been undeclared successfully!',
              })
            })
            .catch(error => {
              this.loading = false
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },
    handleSubjectMarkUpdate: function() {
      this.getClassExamData()
    },
    getClassExamData: function() {
      this.loading = true
      this.$http.get(`/api/classsectionexam/${this.classSectionExamId}`, {
        params: {
          with_students: 1,
          class_section_exam_id: this.classSectionExamId,
        },
      })
        .then(({ data }) => {
          if (data.data.declare_all_section === 1) {
            // eslint-disable-next-line no-unused-expressions
            this.declared_status = 'Exam Declared All Section'
            this.declare_status = 'Declare All Section'
          } else {
            // eslint-disable-next-line no-unused-expressions
            this.declared_status = 'Exam Declared'
            this.declare_status = 'Declare Exam'
          }

          this.classSectionExamData = data.data
          this.activeKey = data.data.declared ? ['2'] : ['1']
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    getStudentSubjectMark: function(marks, subjectId) {
      const examMark = find(marks, { subject_id: subjectId })
      let mark = ''
      if (examMark) {
        if (this.classSectionExamData.grades) {
          mark = examMark.exam_mark_grade ? examMark.exam_mark_grade : '--'
        } else {
          mark = examMark.exam_mark_score ? examMark.exam_mark_score : '--'
        }

        if (examMark.is_absent) {
          mark += '(AB)'
        }
      } else {
        mark = '--'
      }

      return mark
    },
    openMarksFormModal: function(subject) {
      if (this.classSectionExamData.students.length) {
        const examData = omit(this.classSectionExamData, ['class_section_exam_subject'])
        this.loading = true
        this.$http.get(`/api/classsectionexam/${examData.id}`, {
          params: {
            with_students: 1,
            class_section_exam_id: examData.id,
            subject_id: subject.subject.id,
          },
        })
          .then(({ data }) => {
            this.loading = false
            this.$eventBus.$emit('openClassExamMarksForm', subject, examData, data.data.students)
          })
          .catch(error => {
            this.loading = false
            this.$neoNotify.error(error)
          })
      } else {
        this.$message.warning('No students found to add marks for!')
      }
    },
    handleDeclareExam() {
      this.$confirm({
        title: `Are you sure you want to declare exam: ${this.classSectionExamData.exam.name} for class: ${this.classSectionExamData.school_class.name}, section: ${this.classSectionExamData.section.name} ?`,
        content: `Click on the OK button to declare the exam!`,
        onOk: () => {
          if (this.classSectionExamData.has_student_marks) {
            this.loading = true
            const formData = {
              class_section_exam_id: this.classSectionExamId,
            }
            this.$http
              .patch('/api/declareexam', formData)
              .then(() => {
                this.loading = false
                this.$notification['success']({
                  message: 'Successfully declared',
                  description: 'Exam has been declared successfully!',
                })
                this.getClassExamData()
              })
              .catch(error => {
                this.loading = false
                this.$neoNotify.error(error)
              })
          } else {
            this.$error({
              title: 'Cannot declare exam!',
              content: 'Marks not found for the exam!',
            })
          }
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },
  },
}
</script>
